<script lang="ts">
    import {
        DICTIONARY__tmemFilter__Excluded_authors,
        DICTIONARY__tmemFilter__Included_authors,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import TmemCriteriaFilter from "./TmemCriteriaFilter.svelte";
    import type { Author } from "./TmemState";
    import { tmemState } from "./TmemState";

    let container = document.getElementById("authors_included");
    if (container) {
        container.remove();
    }
    container = document.getElementById("authors_excluded");
    if (container) {
        container.remove();
    }
</script>

{#if $tmemState.includedAuthors && $tmemState.includedAuthors.length > 0}
    <TmemCriteriaFilter
        id="authors_included"
        authors={$tmemState.includedAuthors}
        action="include"
        messageCode={DICTIONARY__tmemFilter__Included_authors}
    />
{/if}
{#if $tmemState.excludedAuthors && $tmemState.excludedAuthors.length > 0}
    <TmemCriteriaFilter
        id="authors_excluded"
        authors={$tmemState.excludedAuthors}
        action="exclude"
        messageCode={DICTIONARY__tmemFilter__Excluded_authors}
    />
{/if}
